import axios from 'axios';
import {toastWarning} from "./utils";
import {verifyAndDecodeResponse} from "../services/elevate_cpc.service";

axios.defaults.headers.post['Content-Type'] = 'application/json';
const base_uri = process.env.REACT_APP_MYDQ_API;


export async function invokeApi(reqParams) {

    const {
        path,
        method = 'GET',
        headers = {},
        queryParams = {},
        postData = {},
        ...rest
    } = reqParams;

    let reqObj = {
        method  : method,
        url     : base_uri + path,
        headers : headers,
        ...rest
    };

    reqObj['params'] = queryParams;

    if (method === 'POST') {
        reqObj['data'] = postData;
    }

    let results = undefined;

    try {
        results = await axios(reqObj);
        // if http status is 200, and verifyAndDecodeResponse
        if (results.status === 200 && results.data) {
            const { data, signature } = results.data;
            if (!data || !signature) {
                throw new Error('Invalid response format');
            }
            const decodedData = verifyAndDecodeResponse(results.data);
            if (!decodedData) {
                throw new Error('Invalid signature');
            }
            results.data = decodedData;
        }
        return results.data;
    } catch (error) {

        if (!(error.response && error.response.data && error.response.data.message)) {
            toastWarning('NETWORK ERROR : Some Thing Went Wrong!');
            console.error('debug error: ', error);
            throw new Error('NETWORK ERROR : Some Thing Went Wrong!');
        } else {
            let handled = false;
            if (error.response.status === 499) {
                handled = true;
                throw new Error('Permission denied');
            }

            if(error.response.status === 401) {
                handled = true;
                throw new Error('Unauthorized');
            }

            if (!handled) {
                toastWarning(error.response.data.message);
                throw new Error(error.response.data.message);
            }
        }




    }
}
